import React from "react";
import { Button, Result } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

type LazyRouteBoundaryState = {
  hasError: boolean;
};

type LazyRouteBoundaryProps = {
  children: React.ReactNode;
};

class LazyRouteBoundary extends React.Component<LazyRouteBoundaryProps, LazyRouteBoundaryState> {
  state: LazyRouteBoundaryState = { hasError: false };

  static getDerivedStateFromError(): LazyRouteBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error("Lazy route chunk failed to load:", error);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="warning"
          title="Failed to load page"
          subTitle="The page module could not be loaded. This can happen after a new deployment."
          extra={
            <Button type="primary" icon={<ReloadOutlined />} onClick={this.handleRetry}>
              Reload page
            </Button>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default LazyRouteBoundary;
